import React from 'react';
import styled from 'styled-components';

import { colors } from 'lib/prisma-styles';
import { DARK_THEME } from 'shared/constants';

import { WorkflowFlowBoxProps } from './types';

const StyledContainer = styled.div`
  padding: 1.666666667rem;
  background-color: ${({ theme }) => theme.mode === DARK_THEME ? colors.interactive.defaultBackground : 'rgba(51, 55, 61, 0.04)'};
  border-radius: 8px;
`;

const WorkflowFlowBox = ({
  isOpen,
  contentWhenIsOpen = null,
  contentWhenIsClosed = null,
  className,
}: WorkflowFlowBoxProps) => (
  <StyledContainer className={className}>
    {isOpen
      ? contentWhenIsOpen
      : contentWhenIsClosed
    }
  </StyledContainer>
);

export default WorkflowFlowBox;
